import { CalendarClock } from "lucide-react";

export const PlanningCard = ({ p }) => {
  if (!p) return null;
  const hot = p.start_planning;
  return (
    <div data-testid="planning-card" className={`lux-card p-5 mt-5 flex gap-4 ${hot ? "!border-amber-300/50" : ""}`}>
      <CalendarClock className={`w-6 h-6 shrink-0 ${hot ? "text-amber-300" : "text-slate-500"}`} />
      <div className="text-sm">
        <p data-testid="planning-title" className="font-semibold">{hot ? "Time to start planning!" : "Booking window"}</p>
        <p className="text-slate-400 mt-1">
          The trip leading the vote, <span className="text-slate-200">{p.vacation_title}</span>, is a {p.label.toLowerCase()}: book {p.min_months}–{p.max_months} months out.
          {hot
            ? ` Your estimated wait (~${p.est_wait_months} months) is inside that window — think about dates, time off and travel documents now.`
            : " We'll flag it here when your estimated wait gets inside that window."}
        </p>
      </div>
    </div>
  );
};
